// extracted by mini-css-extract-plugin
export default {"root":"ConversationFooter_root__Sntv+"};